import { Component, inject, input } from '@angular/core';
import {
  ClientNetworkAccessDTO,
  DateTimeRangeDTO,
  ScreenFullDTO,
  SharedClientCentricContentShareAssignmentDTO,
  SharedClientNetworkAccessDTO,
} from '../../services/api/api';
import { UtilService } from '../../services/util.service';
import { ModalService } from '../../services/gui/modal/modal.service';
import { SbDateTimeRangeViewerComponent } from '../controls/sb-date-time-range-viewer/sb-date-time-range-viewer.component';
import { SelectDetailsResult, SelectDetailsValue } from '../../services/gui/modal/modal.model';
import { RoutingID } from '../../routes/sb-routing-enum';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '@ngx-seatback/utils';

@Component({
  selector: 'sb-comp-shared-network-access',
  templateUrl: './shared-network-access.component.html',
  styleUrls: ['./shared-network-access.component.scss'],
  standalone: false,
})
export class SharedNetworkAccessComponent {
  protected readonly util = inject(UtilService);
  protected readonly modal = inject(ModalService);
  protected readonly translate = inject(TranslateService);
  protected readonly navService = inject(NavigationService);

  sharedNetworkAccesses = input.required<SharedClientNetworkAccessDTO[]>();
  isInDeviceContext = input<boolean>(false);
  currentPlaylist: string = '1';

  showDateTimeRanges(ranges: DateTimeRangeDTO[]) {
    this.modal
      .showNavigationModal({
        entryComponent: { value: SbDateTimeRangeViewerComponent, data: { dateTimeRanges: ranges } },
        title: null,
        modalOptions: { size: 'lg' },
      })
      .then(() => {})
      .catch(() => {});
  }

  showScreensModal(screens: ScreenFullDTO[]) {
    if (this.isInDeviceContext()) {
      return;
    }
    const selectDetailsValues: SelectDetailsValue<number>[] = [];

    for (const screen of screens) {
      selectDetailsValues.push({
        name: this.translate.instant('lang.globals.device') + ' ' + screen.device.id,
        value: screen.device.id,
        description: this.translate.instant('lang.globals.screen') + ' ' + screen.id,
      });
    }

    this.modal
      .selectWithDetails({
        values: selectDetailsValues,
        initialValue: null,
        yes: this.translate.instant('lang.globals.showDevice'),
        no: this.translate.instant('lang.globals.cancel'),
        message: '',
        title: 'Screens',
        modalOptions: { size: 'xl' },
      })
      .then((e: SelectDetailsResult<number>) => {
        if (e?.value) {
          this.navService.navigateToPoint(
            RoutingID.deviceDetailsOverview,
            [
              {
                id: 'deviceID',
                value: e.value.value,
              },
            ],
            { target: '_blank' }
          );
        }
      });
  }

  transposeData(clientNetworkAccesses: ClientNetworkAccessDTO[]) {
    if (!clientNetworkAccesses || clientNetworkAccesses.length === 0) {
      return null;
    }
    // get all keys of NetworkAccessPatternDTO without checkOwner and type
    const keys = Object.keys(clientNetworkAccesses[0].accessPattern).filter(key => !key.startsWith('_'));

    // transpose values for display
    return keys.map(key => ({
      label: this.translate.instant('lang.networkShare.' + key),
      values: clientNetworkAccesses.map(row => row.accessPattern[key]),
    }));
  }
}
